import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasGroupSchema = withDefaults({
  type: 'tas-group',
  fields: [
    {
      kind: 'attribute',
      name: 'flavor',
    },
    {
      kind: 'attribute',
      name: 'config',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'hasMany',
      name: 'tasGroupings',
      type: 'tas-grouping',
      options: {
        async: false,
        inverse: 'tasGroup',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'tasGroups',
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'tasGroups',
      },
    },
  ],
});

export default TasGroupSchema;
